export class ServiceFieldValueMessage {
  name: string
  serviceFieldId: number
  value: string

  constructor(name: string, serviceFieldId: number, value: string) {
    this.name = name
    this.serviceFieldId = serviceFieldId
    this.value = value
  }
}
  